import { I as C, j as s, B as z, T as V } from "./Spinner-dTAYYnIx.js";
import { I as S } from "./Image-8P7BYQsX.js";
import { styled as t, css as f } from "styled-components";
import { f as p, m as X, b as _, a as H, t as O, e as n, d as W, p as B } from "./index-QRkynDgW.js";
import { l as D, c as j, a as R, B as E, d as F, q as U, o as I, T as l, s as J } from "./style-8UHgYe1v.js";
import { T as b } from "./typography.styled-aDVGHct9.js";
import { P as K } from "./icon-pin-f4s4rsNY.js";
import { V as N } from "./icon-video-QAWE7HEQ.js";
import { D as Q } from "./domPurify-ugx5Lmst.js";
import { A as k } from "./aspect-ratios-JlfRqse9.js";
const Y = t.div`
  ${p};
  ${X}

  position: relative;
`, Z = t(_)`
  position: relative;
`, ss = t.div.attrs({ $flexBasis: "0", $flexDirection: "column" })`
  ${p}
  ${H}
`, ts = t.div.attrs({
  $flexDirection: "column",
  $justifyContent: "flex-start"
})`
  ${p};

  width: 100%;

  p {
    strong,
    b {
      font-weight: ${D.medium};
    }
  }


  ${O({
  dark: f`
      color: ${j.white};
    `,
  grey: f`
      color: ${j.black};
    `,
  light: f`
      color: ${j.black};
    `
})}
`, es = t(C)`
  position: absolute;
  right: 0;
  bottom: 0;
  margin: ${n.spacer1};
  border-radius: ${W.round};
  background-color: ${j.greyAlpha40};
  padding: ${n.spacer2};

  ${R(
  E.sm,
  f`
      margin: ${n.spacer2};
    `
)}
`, G = t.a`
  cursor: pointer;

  &::after {
    position: absolute;
    inset: 0;
    content: '';
  }

  /* Show "outline" when focused by keyboard only */
  [data-whatintent='keyboard'] &:focus-within {
    outline: 1px solid;
    ${F("outline-color", "dominant")};
    outline-offset: -1px;
  }
`, is = t(b)`
  /* Workaround typography bug forcing all anchor tags inside to be underline */
  ${G} {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
`, ns = t.div`
  ${U(2)};
  ${I(l.labelMedium)}

  padding-top: ${n.spacer4};

  ${({ $layout: e }) => R(
  E.md,
  f`
        padding-top: ${e === "grid" ? n.spacer5 : n.spacer0};
      `
)}
`, os = t.span`
  ${D.medium}
`, rs = t.span.attrs({ $px: { xs: "spacer2" } })`
  ${B}
`, T = t.span`
  font-weight: ${D.normal};
`, as = t.div.attrs({
  $display: "flex",
  $alignItems: "center",
  $pt: { xs: "spacer4" }
})`
  ${p}
  ${B}
  ${I(l.labelS)}

  width: inherit;
`, ys = ({
  image: e,
  primaryTitle: x,
  secondaryTitle: i,
  layout: o = "grid",
  thumbnail: $,
  headingLevel: r = "h3",
  date: a,
  category: c,
  type: d,
  location: u,
  cta: h,
  onClick: m,
  tabIndex: g,
  ...w
}) => {
  const v = e == null ? void 0 : e.src, y = (e == null ? void 0 : e.alt) ?? "", L = {
    xs: {
      src: v,
      maxWidth: 575,
      aspectRatio: k["8:5"]
    }
  }, M = (P) => {
    typeof m == "function" && m(P);
  };
  return /* @__PURE__ */ s.jsxs(
    Y,
    {
      $flexDirection: o === "list" ? { xs: "column", md: "row" } : { xs: "column" },
      $columnGap: o === "list" && { xs: n.spacer1, md: n.spacer4, lg: n.spacer5, xl: n.spacer6 },
      "data-qa": "generic-tile",
      ...w,
      children: [
        /* @__PURE__ */ s.jsxs(
          Z,
          {
            $flexGrow: o === "list" ? { xs: "1" } : { xs: "0" },
            $alignSelf: o === "list" ? "flex-start" : "auto",
            $flexBasis: "0",
            children: [
              /* @__PURE__ */ s.jsx(S, { images: L, alt: y, objectFit: "contain" }),
              $ && /* @__PURE__ */ s.jsx(es, { icon: N, size: 34, color: "white" })
            ]
          }
        ),
        /* @__PURE__ */ s.jsxs(
          ss,
          {
            $flexGrow: o === "list" ? { xs: "1", md: "2" } : { xs: "1" },
            $justifyContent: o === "grid" && { xs: "space-between" },
            children: [
              /* @__PURE__ */ s.jsxs(ts, { children: [
                (a || c || d) && /* @__PURE__ */ s.jsxs(ns, { $layout: o, children: [
                  a && /* @__PURE__ */ s.jsx(os, { "data-qa": "generic-tile-date", children: a }),
                  c && !a && /* @__PURE__ */ s.jsx(T, { "data-qa": "generic-tile-category", children: c }),
                  (c || a) && d && /* @__PURE__ */ s.jsx(rs, { children: "|" }),
                  d && /* @__PURE__ */ s.jsx(T, { "data-qa": "generic-tile-type", children: d })
                ] }),
                /* @__PURE__ */ s.jsx(
                  is,
                  {
                    as: r,
                    $pt: "spacer2",
                    $variant: l.headingXsSans,
                    $textAlign: "left",
                    $textEllipsis: 3,
                    "data-qa": "generic-tile-title",
                    children: h ? /* @__PURE__ */ s.jsx(G, { ...h, tabIndex: g, onClick: M, children: x }) : x
                  }
                ),
                i && /* @__PURE__ */ s.jsx(
                  b,
                  {
                    as: "p",
                    $textEllipsis: 3,
                    $variant: l.body,
                    $pt: "spacer2",
                    "data-qa": "generic-tile-secondaryTitle",
                    dangerouslySetInnerHTML: { __html: Q(i, "simpleInlineRichtext") }
                  }
                )
              ] }),
              u && /* @__PURE__ */ s.jsxs(as, { children: [
                /* @__PURE__ */ s.jsx(C, { icon: K, size: "xs", $pr: "spacer1" }),
                /* @__PURE__ */ s.jsx("span", { "data-qa": "generic-tile-location", children: u })
              ] })
            ]
          }
        )
      ]
    }
  );
}, ls = t.article.attrs({
  $display: "flex",
  $alignItems: "center",
  $justifyContent: "flex-start"
})`
  ${p};

  position: relative;
  gap: ${n.spacer4};
  width: 100%;
`, cs = t.div.attrs({
  $display: "flex",
  $flexDirection: "column",
  $justifyContent: "center"
})`
  ${p};
`, A = t.a`
  cursor: pointer;

  &::after {
    position: absolute;
    inset: 0;
    content: '';
  }

  &:focus {
    outline: none !important;
  }

  [data-whatintent='keyboard'] &:focus-within {
    &::after {
      outline: 1px solid;
      ${F("outline-color", "dominant")};
    }
  }
`, ds = t(b)`
  ${A} {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
`, ps = t(S)`
  ${({ $size: e }) => J(e)}

  flex-shrink: 0;
  border-radius: ${W.round};
  overflow: hidden;
`, xs = t(z)`
  ${({ variant: e }) => e === "inline" && I(l.bodySMedium)}
`, q = {
  xs: 40,
  sm: 64,
  md: 72,
  lg: 120,
  xl: 192
}, ks = ({
  layout: e = "list",
  href: x,
  cta: i,
  secondaryTitle: o,
  primaryTitle: $,
  image: r,
  imageSize: a = "sm",
  variant: c = "secondary",
  theme: d,
  fontVariant: u = "s-serif",
  onChange: h
}) => {
  const m = r == null ? void 0 : r.src, g = (r == null ? void 0 : r.alt) ?? "", w = {
    xs: {
      src: m,
      maxWidth: q[a] * k["22:9"],
      aspectRatio: k["1:1"]
    }
  }, v = (y) => {
    h && h(y);
  };
  return /* @__PURE__ */ s.jsx(V, { theme: d, children: /* @__PURE__ */ s.jsxs(ls, { $flexDirection: e === "grid" ? "column" : "row", "data-qa": "profile-tile", children: [
    /* @__PURE__ */ s.jsx(ps, { $size: q[a], images: w, alt: g, objectFit: "cover" }),
    /* @__PURE__ */ s.jsxs(cs, { $alignItems: e === "grid" ? "center" : "baseline", children: [
      /* @__PURE__ */ s.jsx(
        ds,
        {
          as: "h2",
          $variant: u === "s-serif" ? l.headingSSerif : l.headingXsSerif,
          $textEllipsis: 2,
          children: x ? /* @__PURE__ */ s.jsx(A, { href: x, onClick: v, children: $ }) : $
        }
      ),
      o && /* @__PURE__ */ s.jsx(b, { as: "p", $variant: l.bodyS, children: o }),
      (i == null ? void 0 : i.href) && (i == null ? void 0 : i.text) && /* @__PURE__ */ s.jsx(
        xs,
        {
          variant: c,
          $mt: "spacer1",
          href: i.href,
          "aria-label": $,
          children: i.text
        }
      )
    ] })
  ] }) });
};
export {
  ys as G,
  ks as P
};
